import { Song } from '../types/music';

export const songs: Song[] = [
  {
    id: '28',
    title: 'Хочу другого',
    artist: 'MusCreator',
    genre: 'Russian hip hop, Chorus, Ethereal female voice',
    coverUrl: 'https://cdn2.suno.ai/image_large_442eb640-652a-4394-82e1-60a8c9b51df8.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/ffc8f337-319c-4d8f-898a-f967c85dae86.mp3',
    duration: 199,
    plays: 4347,
    likes: 681,    
  },
  {
    id: '27',
    title: 'Сирота',
    artist: 'MusCreator',
    genre: 'Emotional rap with a melancholic tone, transitioning to a powerful and soaring melodic female vocal chorus with a strong instrumental backdrop (drums, bass, strings), Reflects longing and hope',
    coverUrl: 'https://cdn2.suno.ai/image_large_e8519ef9-84db-4900-984f-ae76fcf7921d.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/e8519ef9-84db-4900-984f-ae76fcf7921d.mp3',
    duration: 239,
    plays: 16841,
    likes: 6894,    
  },
  {
    id: '26',
    title: 'Теплый весенний вечер в Старобельске',
    artist: 'MusCreator',
    genre: 'lofi, lofi pop, female voice, piano, acoustic guitar',
    coverUrl: 'https://api.riffusion.com/storage/v1/object/public/riffs/df733eb1-cfb2-4886-95ea-99553f35ae39/image/bf4ef2e2-0ff2-4ab2-ac21-11b508d70ca3.jpg?w=400&h=400&fit=crop',
    audioUrl: 'https://api.riffusion.com/storage/v1/object/public/riffs/df733eb1-cfb2-4886-95ea-99553f35ae39/audio/bf4ef2e2-0ff2-4ab2-ac21-11b508d70ca3.m4a',
    duration: 207,
    plays: 12343,
    likes: 4583,
    alert: true
  },
  {
    id: '25',
    title: 'Праздник весны',
    artist: 'MusCreator',
    genre: 'Traditional Arab Ramadan, romantic, dafli percussion, spiritual meditative rhythms, melodic',
    coverUrl: 'https://api.riffusion.com/storage/v1/object/public/riffs/df733eb1-cfb2-4886-95ea-99553f35ae39/image/701524a2-1d31-49b0-be69-fd97323bb4fc.jpg?w=400&h=400&fit=crop',
    audioUrl: 'https://api.riffusion.com/storage/v1/object/public/riffs/df733eb1-cfb2-4886-95ea-99553f35ae39/audio/701524a2-1d31-49b0-be69-fd97323bb4fc.m4a',
    duration: 190,
    plays: 14712,
    likes: 6814,
    alert: true
  },
  {
    id: '24',
    title: 'Танцую в Прада',
    artist: 'MusCreator',
    genre: 'Ethereal Vocals, heavy drum beat, 120bpm dance moody dark, female vocals, spicy drop',
    coverUrl: 'https://api.riffusion.com/storage/v1/object/public/riffs/df733eb1-cfb2-4886-95ea-99553f35ae39/image/364a1853-ead8-4fbf-a414-0fe158e8c350.jpg?w=400&h=400&fit=crop',
    audioUrl: 'https://api.riffusion.com/storage/v1/object/public/riffs/df733eb1-cfb2-4886-95ea-99553f35ae39/audio/28f91fc1-5bf0-4124-9e99-eb0f3f7b17b2.m4a',
    duration: 176,
    plays: 12587,
    likes: 5971,
    alert: true
  },
  {
    id: '23',
    title: 'Молитва о близких',
    artist: 'MusCreator',
    genre: 'dream pop, sonic textures, synthesizer, male deep vocal, emotional',
    coverUrl: 'https://api.riffusion.com/storage/v1/object/public/riffs/df733eb1-cfb2-4886-95ea-99553f35ae39/image/83083b6f-97b8-45de-8dbc-e5e5f5bea6e1.jpg?w=400&h=400&fit=crop',
    audioUrl: 'https://api.riffusion.com/storage/v1/object/public/riffs/df733eb1-cfb2-4886-95ea-99553f35ae39/audio/83083b6f-97b8-45de-8dbc-e5e5f5bea6e1.m4a',
    duration: 206,
    plays: 13748,
    likes: 6941,
    alert: true
  },
  {
    id: '22',
    title: 'Не скованные',
    artist: 'MusCreator',
    genre: 'Power ballad, soul, 1950s/60s, lush orchestration (strings, piano), emotive tenor vocals, romantic/yearning mood, themes of lost love & longing, building dynamics to a powerful climax, doo-wop and R&B',
    coverUrl: 'https://cdn2.suno.ai/image_ed52a687-8451-4a73-b2c6-4a5f37afd705.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/5f042a63-1f6c-4394-9da1-6f0787c45ea1.mp3',
    duration: 189,
    plays: 12401,
    likes: 3641
  },
  {
    id: '21',
    title: 'Твист',
    artist: 'MusCreator',
    genre: '60s,  fast tempo,  rock and roll,  guitar,  drums,  saxophone,  upbeat,  teenage love,',
    coverUrl: 'https://cdn2.suno.ai/image_b52c3dfc-60e6-4130-b45a-7b10e66d60ca.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/b52c3dfc-60e6-4130-b45a-7b10e66d60ca.mp3',
    duration: 195,
    plays: 6274,
    likes: 2142
  },
  {
    id: '20',
    title: 'Да здравствует вечность',
    artist: 'MusCreator',
    genre: '90s style acoustic pop ballad, girls band, moderate tempo, prominent acoustic guitar, strings, light percussion, flute melodies, layered female vocals with harmonies, nostalgic atmosphere,',
    coverUrl: 'https://cdn2.suno.ai/image_large_e6d4ff5a-57e1-4007-bd70-860fb80267ce.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/0b1d3477-58e7-4e9c-8afa-39dd92052c46.mp3',
    duration: 179,
    plays: 7348,
    likes: 2846
  },
  {
    id: '19',
    title: 'С Новым годом',
    artist: 'MusCreator',
    genre: 'Nostalgic pop ballad, moderate tempo, piano, strings, acoustic guitar, male and female vocals with harmonies, emotional melody',
    coverUrl: 'https://cdn2.suno.ai/image_large_6c1762b6-f00f-4603-ae6c-bb7aa2960a0c.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/6c1762b6-f00f-4603-ae6c-bb7aa2960a0c.mp3',
    duration: 240,
    plays: 9115,
    likes: 3581
  },
  {
    id: '18',
    title: 'ака Nightwish - Ария о Винни пухе и Пяточке',
    artist: 'MusCreator',
    genre: 'Epic metal opera',
    coverUrl: 'https://cdn2.suno.ai/image_57300b45-9728-483a-8eaf-3390ec0833b1.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/849de962-7a82-48ab-9511-434cfe3598a9.mp3',
    duration: 228,
    plays: 7487,
    likes: 1243
  },
  {
    id: '17',
    title: 'Новогодняя 2',
    artist: 'MusCreator',
    genre: 'Festive Eastern European party song, upbeat tempo, accordion, brass, percussion, catchy melody, repetitive chorus, joyful and energetic',
    coverUrl: 'https://cdn2.suno.ai/image_bff0a0f1-9207-49a1-99d4-343a037f61f4.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/bff0a0f1-9207-49a1-99d4-343a037f61f4.mp3',
    duration: 147,
    plays: 9341,
    likes: 3178
  },
  {
    id: '16',
    title: 'Лирическая 2 (v.2)',
    artist: 'MusCreator',
    genre: 'High-energy K-Pop track with a viral hook,  fast tempo,  heavy electronic influences,  synth melodies,  siren sound effects,  powerful vocals,  dance beat',
    coverUrl: 'https://cdn2.suno.ai/image_large_d852c1dd-5034-47be-a23f-cd56667b0e6a.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/d852c1dd-5034-47be-a23f-cd56667b0e6a.mp3',
    duration: 203,
    plays: 4298,
    likes: 581
  },
  {
    id: '15',
    title: 'Лирическая 2 (v.1)',
    artist: 'MusCreator',
    genre: 'High-energy K-Pop track with a viral hook,  fast tempo,  heavy electronic influences,  synth melodies,  siren sound effects,  powerful vocals,  dance beat',
    coverUrl: 'https://cdn2.suno.ai/image_d852c1dd-5034-47be-a23f-cd56667b0e6a.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/849edb82-b6f0-4e0d-8b4b-023b3bf4726b.mp3',
    duration: 189,
    plays: 2594,
    likes: 862
  },
  {
    id: '14',
    title: 'Лирическая',
    artist: 'MusCreator',
    genre: 'Atmospheric rock, melancholic, reflective, with a touch of nostalgia, simple instrumentation',
    coverUrl: 'https://cdn2.suno.ai/image_7ac4f3d6-3dee-4922-ad50-1159c41ce878.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/7ac4f3d6-3dee-4922-ad50-1159c41ce878.mp3',
    duration: 192,
    plays: 4781,
    likes: 364
  },
  {
    id: '13',
    title: 'Воины света (энергетикам посвящается)',
    artist: 'MusCreator',
    genre: 'Heroic rock ballad,  powerful vocals,  driving guitars,  anthemic',
    coverUrl: 'https://cdn2.suno.ai/image_fa76e20f-dfce-4bf3-ad3f-25c7a1c5e0ca.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/fa76e20f-dfce-4bf3-ad3f-25c7a1c5e0ca.mp3',
    duration: 177,
    plays: 5791,
    likes: 641
  },
  {
    id: '12',
    title: 'Loli Pop',
    artist: 'MusCreator',
    genre: 'drum and bass,  dance pop, violin, minor, metal',
    coverUrl: 'https://cdn2.suno.ai/image_8c0f3cfd-34f2-4200-89bb-4be2a52f64f2.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/8c0f3cfd-34f2-4200-89bb-4be2a52f64f2.mp3',
    duration: 199,
    plays: 5321,
    likes: 456
  },
  {
    id: '11',
    title: 'Эхо скрипки',
    artist: 'MusCreator',
    genre: 'drum and bass,  dance pop, violin, minor, metal',
    coverUrl: 'https://cdn2.suno.ai/image_large_9b013808-f57b-4e51-a526-ef714357cd9b.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://storage.googleapis.com/udio-artifacts-c33fe3ba-3ffe-471f-92c8-5dfef90b3ea3/samples/9e8db383032d4122817977df3fc134be/1/Echoes%2520of%2520the%2520Violine%2520ext%2520v2.1.1.2.1.2.1.mp3',
    duration: 218,
    plays: 6322,
    likes: 321,
    alert: true
  },
  {
    id: '10',
    title: 'ака Ария - Ария о Винни пухе и Пяточке',
    artist: 'MusCreator',
    genre: 'rock, heavy metal, rock opera, duet, группа Ария',
    coverUrl: 'https://cdn2.suno.ai/image_c2099b0c-02f8-4590-8976-20ccb3e1e83f.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://storage.googleapis.com/udio-artifacts-c33fe3ba-3ffe-471f-92c8-5dfef90b3ea3/samples/63ed5792f37b444497c7526041e6a2fe/1/%25C3%2590%25C2%2593%25C3%2591%25C2%2580%25C3%2590%25C2%25BE%25C3%2590%25C2%25B7%25C3%2590%25C2%25BE%25C3%2590%25C2%25B2%25C3%2590%25C2%25B0%25C3%2591%25C2%258F%2520%25C3%2590%25C2%25A1%25C3%2590%25C2%25B8%25C3%2590%25C2%25BC%25C3%2591%25C2%2584%25C3%2590%25C2%25BE%25C3%2590%25C2%25BD%25C3%2590%25C2%25B8%25C3%2591%25C2%258F%2520ext%2520v1.1.1.1.1.mp3',
    duration: 195,
    plays: 5724,
    likes: 187,
    alert: true
  },
  {
    id: '9',
    title: 'ака КиШ - Мойдодыр',
    artist: 'MusCreator',
    genre: 'Folk punk, Horror punk, Король и Шут, КиШ, Korol & Shut, Михаил Горшенев',
    coverUrl: 'https://cdn2.suno.ai/f4887048-c3eb-4334-955e-5e99dfe5c07d_178b1af5.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://storage.googleapis.com/udio-artifacts-c33fe3ba-3ffe-471f-92c8-5dfef90b3ea3/samples/ae8f04cebf9445198712a82f2e59de86/2/%25C3%2590%25C2%259A%25C3%2591%25C2%2580%25C3%2591%25C2%2583%25C3%2590%25C2%25B3%25C3%2590%25C2%25BE%25C3%2590%25C2%25BC%2520%25C3%2590%25C2%2597%25C3%2590%25C2%25B0%25C3%2590%25C2%25B2%25C3%2590%25C2%25B5%25C3%2591%25C2%2580%25C3%2591%25C2%2582%25C3%2590%25C2%25B5%25C3%2590%25C2%25BB%25C3%2590%25C2%25BE%25C3%2591%25C2%2581%25C3%2591%25C2%258C%2520ext%2520v1.2.1.2.1.2.mp3',
    duration: 228,
    plays: 3177,
    likes: 261,
    alert: true
  },
  {
    id: '8',
    title: 'Вечность (любимой жене посвящается)',
    artist: 'MusCreator',
    genre: 'synthwave, dance, EDM, pop, Руки Вверх, nostalgic, male vocalist',
    coverUrl: 'https://cdn2.suno.ai/a113e567-c0e4-4d54-819e-383b42276e3e_9cc9ce83.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://storage.googleapis.com/udio-artifacts-c33fe3ba-3ffe-471f-92c8-5dfef90b3ea3/samples/4b39d01768144493a502aae67dec168e/2/Whisper%2520of%2520an%2520Angel%2520ext%2520v1.2.2.2.2.2.1.2.2.mp3',
    duration: 327,
    plays: 8310,
    likes: 648,
    alert: true
  },
  {
    id: '7',
    title: 'Краски в лужах',
    artist: 'MusCreator',
    genre: 'angelic voice, dance-pop, dance, Serena, synth serena, synthwave',
    coverUrl: 'https://cdn2.suno.ai/d3b7152d-6877-4fbe-bdde-afd72e5716ea_9a874c46.jpeg',
    audioUrl: 'https://storage.googleapis.com/udio-artifacts-c33fe3ba-3ffe-471f-92c8-5dfef90b3ea3/samples/20e956f1b1054f24895c25a7412f121d/1/The%2520Untitled.mp3',
    duration: 256,
    plays: 5449,
    likes: 411,
    alert: true
  },
  {
    id: '6',
    title: 'Новогодняя',
    artist: 'MusCreator',
    genre: 'Upbeat childrens Christmas pop with a 60s influence,  fast tempo,  bright and festive',
    coverUrl: 'https://cdn2.suno.ai/image_d5a4e59c-2b8f-4b8f-ab0e-f539316c9796.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/d5a4e59c-2b8f-4b8f-ab0e-f539316c9796.mp3',
    duration: 114,
    plays: 862,
    likes: 231
  },
  {
    id: '5',
    title: 'Hot Room (v2)',
    artist: 'MusCreator',
    genre: 'Rhythmical Lyrical heavy rock opera, Eternal Anglican voice',
    coverUrl: 'https://cdn2.suno.ai/image_a6f55cc3-445d-48a6-8c8e-bf50b9dc5258.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/a6f55cc3-445d-48a6-8c8e-bf50b9dc5258.mp3',
    duration: 213,
    plays: 3102,
    likes: 526
  },
  {
    id: '4',
    title: 'Теперь я свободен',
    artist: 'MusCreator',
    genre: 'Prop rock, slow tempo, melodic rock, sad mood',
    coverUrl: 'https://cdn2.suno.ai/image_2cb18157-328e-452d-b93c-b6c4ae2d914a.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/a6db776a-9157-44e3-a1b6-157ad8720a42.mp3',
    duration: 262,
    plays: 3391,
    likes: 457
  },
  {
    id: '3',
    title: 'Hot Room',
    artist: 'MusCreator',
    genre: 'Rock opera, rock ballad',
    coverUrl: 'https://cdn2.suno.ai/bcc7137c-4b55-404d-a2dc-baacebab0d4d_63985270.jpeg',
    audioUrl: 'https://cdn1.suno.ai/9574d25d-b11e-4f4d-a2c1-435fdc6299af.mp3',
    duration: 120,
    plays: 11014,
    likes: 1547
  },
  {
    id: '2',
    title: 'Песня про пиво',
    artist: 'MusCreator',
    genre: 'dance-pop, synthwave / electro, synth-pop, electropop, female vocalist',
    coverUrl: 'https://images.unsplash.com/photo-1555661059-7e755c1c3c1d?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/1be173ab-8a22-40f1-a481-512fb7e109ed.mp3',
    duration: 183,
    plays: 13578,
    likes: 2215
  }
  ,
  {
    id: '1',
    title: 'Bada Boom',
    artist: 'MusCreator',
    genre: 'pop,  electro,  house,  female vocalist',
    coverUrl: 'https://cdn2.suno.ai/image_8def9afe-dffd-4ec9-b55e-c292c3febdbf.jpeg?w=400&h=400&fit=crop',
    audioUrl: 'https://cdn1.suno.ai/8def9afe-dffd-4ec9-b55e-c292c3febdbf.mp3',
    duration: 209,
    plays: 9818,
    likes: 4911
  }
];
